// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

import { NAV_SIDEBAR_WIDTH } from "metabase/nav/constants";
import { Card } from "metabase/ui";

export const BulkActionsToast = styled.div<{ isNavbarOpen: boolean }>`
  position: fixed;
  bottom: 0;
  left: 50%;
  margin-left: ${(props) =>
    props.isNavbarOpen ? `${parseInt(NAV_SIDEBAR_WIDTH) / 2}px` : "0"};
  margin-bottom: var(--mantine-spacing-md);
  transform: translateX(-50%);
  z-index: 150;
`;

export const ToastCard = styled(Card)`
  background-color: var(--mb-color-background-primary-inverse);
  color: var(--mb-color-text-primary-inverse);
  padding: 0.75rem var(--mantine-spacing-md);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 2.5rem;
` as unknown as typeof Card;
